export default __webpack_public_path__ + "static/media/avatar.f95a7fa4.jpg";